<template>
  <div class="wrap-due-created">
    <div v-if="data" class="up">
      <span class="day">{{
        `${dayjs.utc(data).local().format("DD.MM.YYYY")}.`
      }}</span>
      <span class="time">
        {{ `${dayjs.utc(data).local().format("HH:mm")}` }}
      </span>
    </div>
    <div v-if="created" class="down">
      <span class="day">{{
        `${dayjs.utc(created).local().format("DD.MM.YYYY")}.`
      }}</span>
      <span class="time">
        {{ `${dayjs.utc(created).local().format("HH:mm")}` }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
const props = defineProps(["data", "created"]);
</script>

<style lang="scss">
.wrap-due-created {
  min-width: 99px;
  // height: 100%;
  .up {
    max-height: 14px;
    .day {
      // font-weight: 700;
      // font-size: 15px;
      // line-height: 11px;
      font-weight: 600;
      font-size: 13px;
      line-height: 15px;
      white-space: nowrap;
    }
    .time {
      margin-left: 7px;
      // font-weight: 400;
      // font-size: 11px;
      // line-height: 11px;
      font-weight: 400;
      font-size: 9px;
      line-height: 15px;
      white-space: nowrap;
      //   color: var(--color-path-link);
    }
  }
  .down {
    // max-height: 18px;
    // max-height: 12px;
    text-align: right;
    .day {
      // font-weight: 700;
      // font-size: 15px;
      // line-height: 16px;
      font-weight: 400;
      font-size: 9px;
      line-height: 19px;
      white-space: nowrap;
      color: var(--color-path-link);
    }
    .time {
      margin-left: 7px;
      // font-weight: 400;
      // font-size: 11px;
      // line-height: 15px;
      font-weight: 400;
      font-size: 9px;
      line-height: 9px;
      white-space: nowrap;
      color: var(--color-path-link);
    }
  }
}
</style>
